module.exports = __webpack_public_path__ + "static/media/spinner.7f0dd500.svg";